export class AccessDataByEmailInputModel {
    contactNumber: string;
    account: AccountModel;
}
export class AccountModel {
    status: string;
    accountNumber: string;
    name: string;
    privileges: PrivilegeModel[] = [];
    companyId?: string;
    type: string;
}
export class PrivilegeModel {
    name: string
    constructor(privilegeName: string) {
        this.name = privilegeName;
    }
}